<template>
  <div class="headerall">
    <div class="headerdl">
      <img v-if="hospLogo" :src="hospLogo" class="logo" />
      <div class="login" v-if="showPro">
        <span @click="showDL">登录 / 注册</span>
        <span style="display:none">|</span>
        <span @click="showZC" style="display:none">注册</span>
      </div>

      <div class="right-menu" v-else>
        <el-popover
          placement="top-start"
          v-model="popovershow"
          title="消息"
          width="400"
          trigger="hover"
          @show="showList"
        >
          <div class="messagelist">
            <div v-for="(item,i) in msgList" :key="i" :title="item.notice_msg">
              <p @click="clickToProcess(item.act_post_id)">{{item.notice_msg}}</p>
            </div>
          </div>
          <span class="messageshow" slot="reference">
            <i class="el-icon-message"></i>
            <b>{{msgCount}}</b>
          </span>
        </el-popover>

        <router-link to="/process"><span class="myResume">我的投递({{total}})</span></router-link>

        <el-dropdown class="avatar-container right-menu-item hover-effect" @command="commandDown" trigger="click">
          <div class="avatar-wrapper">
            <span class="usershow">您好***{{userName}}</span>
            <img :src="avatar" class="user-avatar" />
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/user">
              <el-dropdown-item command="/user">个人中心</el-dropdown-item>
            </router-link>
            <router-link to="/process">
              <el-dropdown-item command="/process">投递进程</el-dropdown-item>
            </router-link>
            <router-link :to="{name:'editPassword', params: {phone:phone}}">
              <el-dropdown-item command="/forget-password">修改密码</el-dropdown-item>
            </router-link>
            <router-link to="/privacy">
              <el-dropdown-item command="/privacy">隐私政策</el-dropdown-item>
            </router-link>
            <router-link to="/complaint">
              <el-dropdown-item command="/complaint">投诉反馈</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click.native="logout" command="/exitLogin">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="navheader pcshow">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#409EFF"
        active-text-color="#fff"
        router
        :default-active="$store.state.currentActiveMenu"
      >
        <el-menu-item
          v-for="v in menuList"
          :key="v.path"
          :index="v.path"
        >{{ v.label }}</el-menu-item>
      </el-menu>
    </div>
  <div class="navheader mobileshow">
    <el-menu
    class="el-menu-demo"
    mode="horizontal"
    @select="handleSelect"
    menu-trigger="click"
      router
      :default-active="$store.state.currentActiveMenu"
    >
        <el-submenu index="/">
          <template slot="title">菜单列表</template>
          <el-menu-item
            v-for="v in menuList"
            :key="v.path"
            :index="v.path"
          >{{ v.label }}</el-menu-item>
    </el-submenu>
    </el-menu>
  </div>


  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { getStyleList, getMsgCount, getMsgList } from "@/api/webStyle";
import { processList } from "@/api/process";
export default {
  data() {
    return {
      popovershow: false, //消息框
      imgBasePath: process.env.API_ROOT,
      hospLogo: "",
      avatar: undefined,
      phone:'',
      userName: "",
      showPro: true,
      msgCount: 0,
      msgList: [],
      menuList: [
        {
          path: '/',
          label: '首页'
        },
        {
          path: '/campus',
          label: '校园招聘'
        },
        {
          path: '/society',
          label: '社会招聘'
        },
        {
          path: '/highlevel',
          label: '高层次人才招聘'
        },
        {
          path: '/hospital',
          label: '医院概况'
        }
      ],
      total:0,
      queryData: {
        pageNum: 1,
        pageSize: 10,
        resumeId: ""
      },
    };
  },
  created() {
    this.watchSpecialHospital();
    this.getInfo(); //获取用户信息
    this.getStyleList();
    this.getMsgCount();
    this.initActiveTab();
    this.getList();
  },

  computed: {},

  methods: {
    watchSpecialHospital() {
      let orgCode = location.hostname;
      if (orgCode.includes('gzzxyjh')) {
        this.menuList = [
          {
            path: '/',
            label: '人才招聘'
          },
          {
            path: '/highlevel',
            label: '高层次人才招聘'
          },
          {
            path: '/hospital',
            label: '医院概况'
          }
        ]
      }
    },

    initActiveTab() {
      let active = sessionStorage.getItem('currentActiveMenu')
      if (active && active !== 'null') this.handleSelect(active)
      else this.handleSelect('/')
    },

    //点击消息列表到process页面
    clickToProcess(act_post_id) {
      this.popovershow = false;
      if (this.$router.currentRoute.path == "/process") {
        let url = location.href;
        let dataIndex = url.indexOf("activeNames=");
        url = url.substring(0, dataIndex);
        url = url + "activeNames=" + act_post_id;
        location.reload();
      } else {
        this.$router.push({
          path: "/process",
          query: { activeNames: act_post_id }
        });
      }
    },
    //过滤html标签
    filterHTMLTag(msg) {
      if (msg) {
        var msg = msg.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
        msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
        msg = msg.replace(/&npsp;/gi, ""); //去掉npsp
      }

      return msg;
    },
    //消息列表
    showList() {
      if (this.msgList.length > 0) return false;
      let data = {
        pageNum: 1,
        pageSize: 200
      };

      getMsgList(data).then(res => {
        if (res.code == "200") {
          this.msgList = res.rows;
          this.msgList.map(item => {
            item.notice_content = this.filterHTMLTag(item.notice_content);
            item.notice_msg = this.filterHTMLTag(item.notice_msg);
          });
        }
      });
    },
    //消息数量
    getMsgCount() {
      if (this.showPro == true) return;
      getMsgCount().then(res => {
        if (res.code == "200") {
          this.msgCount = res.data.count;
        }
      });
    },

    commandDown(item) {
      this.handleSelect(item)
    },

    handleSelect(key) {
      this.$store.commit('SET_KEY', {
        key: 'currentActiveMenu',
        value: key
      })
      sessionStorage.setItem('currentActiveMenu', key)
    },
    showDL() {
      this.$router.push("/login");
    },
    showZC() {
      this.$router.push({ path: "/login", query: { isregister: 1 } });
    },
    async logout() {
      this.$confirm("确定退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    },
    //获取用户详情
    getInfo() {
      let token = getToken();
      if (token) {
        var that = this;
        this.showPro = false;
        this.$store.dispatch("GetInfo").then(res => {

          that.avatar = that.$store.state.avatar;
          that.phone = that.$store.state.name;
          that.userName = that.phone.substr(that.phone.length - 4);
          window.localStorage.setItem("resume_id", res.resumeId);
        });
      } else {
        this.showPro = true;
      }
    },

    getStyleList() {
      getStyleList().then(res => {
        if (res.code == "200") {
          //
          if (res.rows.length > 0)
            this.hospLogo = this.imgBasePath + res.rows[0].hospLogo;
        }
      });
    },

    getList() {
      this.queryData.resumeId = window.localStorage.getItem("resume_id");
      debugger
      let token = getToken();
      if (token) {
        processList(this.queryData).then(res => {
          if (res.code == "200") {
            this.total = res.total;
            this.dataList = res.rows;
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.messageshow {
  display: inline-block;
  cursor: pointer;
  b {
    font-weight: normal;
    position: absolute;
    top: -13px;
    left: 18px;
    font-size: 12px;
    color: #f00;
  }
  i {
    font-size: 20px;
  }
}
.messagelist {
  max-height: 400px;
  overflow-y: auto;
  p {
    line-height: 26px;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.headerall {
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
}
.headerdl {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.navheader {
  margin: 0 auto;
  /deep/ .el-menu.el-menu--horizontal{
    border-bottom:1px solid #ddd;
    padding-bottom: 2px;
    box-sizing: border-box;
    & > .el-menu-item.is-active {
      font-weight: bold;
      color: #fff;
    }
  }
}
.pcshow{display:block}
.mobileshow{display:none}
.logo {
  position: absolute;
  top: 7px;
  width: auto;
  max-width: 300px;
  height: 46px;
  min-height: 30px;
  z-index: 10;
}
.el-menu-item:hover {
  outline: 0 !important;
  color: #fff !important;
  background: none !important;
  font-weight: bold;
}
.el-menu.el-menu--horizontal {
  text-align: center;
}
.el-menu--horizontal > .el-menu-item {
  float: none;
  display: inline-block;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  background-color: #409EFF !important;
}
.login {
  position: absolute;
  right: 0;
  top: 21px;
  z-index: 10;
  color: rgba(255,255,255,.85);
  span {
    float: right;
    padding-right: 5px;
    padding-left: 5px;
    cursor: pointer;
  }
  span:hover {
    font-weight: bold;
    color: #fff;
  }
}
.right-menu {
  position: absolute;
  right: 0;
  top: 5px;
  color: rgba(255,255,255,.85);
  height: 50px;
  z-index: 9;
  display: flex;
  align-items: center;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: rgba(255,255,255,.85);
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;
    animation: blink 1s infinite alternate;
    .avatar-wrapper {
      margin-top: 8px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 40px;
      }
      .usershow {
        font-size: 12px;
        position: relative;
        top: -8px;
      }
      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 13px;
        font-size: 12px;
      }
    }
  }
  .myResume {
    font-size: 12px;
    color: white;
    position: relative;
    left:5px;
    right:5px;
  }
}

@media screen and (max-width: 500px) {
    .headerdl {
  width: 100%;
}
.logo{display:none}
.pcshow{display:none}
.mobileshow{display:block}
  .login{
    color: #000;
    font-size: 12px;
  }
  .right-menu .myResume {
    font-size: 12px;
    color: #000;
    left:5px;
    right:5px;
  }
}
@keyframes blink {
  0% {
    color: #FF7F50; /* 橙色 */
  }
  14% {
    color: #FFE4E1; /* 粉色 */
  }
  28% {
    color: #D2691E; /* 棕色 */
  }
  42% {
    color: #6495ED; /* 蓝色 */
  }
  56% {
    color: #00BFFF; /* 青色 */
  }
  70% {
    color: #0000FF; /* 蓝色 */
  }
  84% {
    color: #008000; /* 绿色 */
  }
  100% {
    color: #FF7F50; /* 返回原始颜色，橙色 */
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue